import GeneralInformation from "@/services/GeneralInformation";

export default {
  namespaced: true,

  state: () => ({
    id: null,
    logo: null,
    login_vector: null,
    primary_color: null,
    head_count: null,
    loaded: false, // 🔑 important
    paid_leave: null,
    pf_proration: 0,
    rename_pf: null,
    // offer_letter_expiry: null,
    is_organisation_level_breakup: null,
    auto_machine_id: null,
  }),

  mutations: {
    SET_SYSTEM_INFO(state, payload) {
      state.id = payload.id;
      state.logo = payload.logo;
      state.login_vector = payload.login_vector;
      state.primary_color = payload.primary_color;
      state.head_count = payload.head_count;
      state.loaded = true;
      state.paid_leave = payload.paid_leave;
      state.pf_proration = payload.pf_proration;
      state.rename_pf = payload.rename_pf;
      // state.offer_letter_expiry = payload.offer_letter_expiry;
      state.is_organisation_level_breakup = payload.is_organisation_level_breakup;
      if (payload.auto_machine_id !== undefined) {
        state.auto_machine_id = payload.auto_machine_id;
      }
    },
    SET_LOADED(state, status) {
      state.loaded = status;
    },
    SET_ORGANISATION_LEVEL_BREAKUP(state, status) {
      state.is_organisation_level_breakup = status;
    },
  },

  actions: {
    async fetchSystemInfo({ state, commit }) {
      // Prevent refetch
      if (state.loaded) return;

      try {
        // Replace with your API
        const response = await GeneralInformation.fetchGeneralInformation();
        const data = response.data;

        commit("SET_SYSTEM_INFO", {
          id: data.id,
          logo: data.logo,
          login_vector: data.login_vector,
          primary_color: data.primary_color,
          head_count: data.total_head_count,
          paid_leave: data.paid_leave,
          pf_proration: Number(data.pf_proration) || 0,
          rename_pf: data.rename_pf ?? null,
          // offer_letter_expiry: data.offer_letter_expiry,
          is_organisation_level_breakup: data.is_organisation_level,
          auto_machine_id: data.auto_machine_id,
        });
      } catch (error) {
        console.error("Failed to load system info", error);
      }
    },
    async updateSystemInfo({ state, commit, dispatch }, payload) {
      try {
        // Create FormData for file uploads
        const formData = new FormData();

        if (payload.app_logo && payload.app_logo instanceof File) {
          formData.append("logo", payload.app_logo);
        }
        if (payload.login_vector && payload.login_vector instanceof File) {
          formData.append("login_vector", payload.login_vector);
        }
        formData.append("primary_color", payload.primary_color);
        formData.append("pf_proration", payload.pf_proration ? 1 : 0);
        // if (payload.offer_letter_expiry !== null && payload.offer_letter_expiry !== undefined && payload.offer_letter_expiry !== "") {
        //   formData.append("offer_letter_expiry", payload.offer_letter_expiry);
        // }
        formData.append("auto_machine_id", payload.auto_machine_id);
        // formData.append("total_head_count", payload.head_count);

        // Call API to update database
        const response = await GeneralInformation.updateGeneralSetting(
          state.id,
          formData,
        );
        console.log('res', response.data)
        if (response && response.success) {
          // After successful DB update, refresh store data
          console.log('1')
          commit('SET_LOADED', false);
          console.log('2')
          await dispatch("fetchSystemInfo");
          console.log('3')
          return {
            success: true,
            message: "System configuration updated successfully",
            data: response.data,
          };
        } else {
          throw new Error(response.data?.message || "Update failed");
        }
      } catch (error) {
        console.error("Error updating system info:", error);
        return {
          success: false,
          message:
            error.response?.data?.message ||
            error.message ||
            "Error updating configuration",
        };
      }
    },
  },

  getters: {
    systemLogo: (state) => state.logo,
    loginVector: (state) => state.login_vector,
    primaryColor: (state) => state.primary_color,
    headCount: (state) => state.head_count,
    paidLeave: (state) => state.paid_leave,
    pfProration: (state) => state.pf_proration,
    // rename_pf is null until set in Payroll > General > PF Display Name
    pfLabel: (state) => state.rename_pf?.trim() || "Provident Fund",
    // offerLetterExpiry: (state) => state.offer_letter_expiry,
    isOrganisationLevelBreakup: (state) => state.is_organisation_level_breakup,
    autoMachineId: (state) => state.auto_machine_id,
  },
};
